import React, { useState } from "react";
import { Pie } from '@ant-design/charts';
import { Divider, Row, Col, Space } from "antd";
import { addCommas } from "../../utils/Utils";
export default function TrafficSources(props) {

    const {referrers = {}} = props; 

    const sources = [
        { label: "Direct", color: "#6895c7" },
        { label: "Search", color: "#6082a1" },
        { label: "Referral", color: "#b0cc98" },
        { label: "Social Media", color: "#78b283" },
    ]


    const results = {
        "datasets": [
            {
                "data": [
                    parseInt(referrers["Direct"] || 0),
                    parseInt(referrers["Search"] || 0),
                    parseInt(referrers["Referral"] || 0),
                    parseInt(referrers["Social Media"] || 0),
                ]
            }
        ],
        "labels": [
            "Direct",
            "Search",
            "Referral",
            "Social Media",
        ],
        "date_labels": false
    }


    const [hover, setHover] = useState({ key: "", value: 0, opacity: 0 })
   
    const parseData = () => {
        let arr = [];
        results.labels.forEach((_label, _index) => {
            arr.push({
                label: _label,
                value: parseInt(results.datasets[0].data[_index])
            })
        });
        return arr;
    }

    const getColor = (_t) => {
        let ret = "#6895c7";
        let _f = sources.find(item => item.label === _t.label);
        if (_f) {
            ret = _f.color;
        }
        return ret;
    }

    const config = {
        appendPadding: 10,
        data: parseData(),
        angleField: 'value',
        colorField: 'label',
        color: (t) => getColor(t),
        radius: 1,
        height: 245,
        innerRadius: 0.7,
        legend: false,
        label: {
            type: 'inner',
            offset: '-50%',
            content: "",
        },
        statistic: {
            title: false,
            content: {
                style: {
                    whiteSpace: 'pre-wrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                content: '',
                customHtml: (_container, _view, _datum, _data) => {
                    return (
                        <>
                            <div style={{ "opacity": hover.opacity }}>
                                <div className="c"><small>{addCommas(hover.value)}</small></div>
                                <div className="c2" style={{ "fontWeight": "normal", "fontSize": "18px", "opacity": 0.7 }}><small>{hover.key}</small></div>
                            </div>
                        </>
                    )
                }
            },
        },
    };

    const updateHover = (_label) => {

        if (!_label) {
            setHover({ ...hover, opacity: 0 });
            return;
        }

        let _data = parseData();
        let _find = _data.find(item => item.label === _label);
        if (_find) {
            setHover({ key: _label, value: _find.value, opacity: 1 });
        } else {
            setHover({ ...hover, opacity: 0 });
        }
    }

    return (
        <>
            <strong className="c" style={{ "fontSize": "13px" }}>Traffic sources</strong>
            <div style={{ "fontSize": "14px" }}><small>Breakdown of website visits by referral channel and origin.</small></div>
            <Divider dashed style={{ "margin": "10px 0px" }} />
            <Row gutter={15}>
                <Col flex={"200px"}><Pie animation={null} {...config} /></Col>
                <Col flex={"100px"}>
                    <br /><br />
                    <Space size={0} direction="vertical">
                        {sources.map(item => {
                            return (
                                <div style={{ "cursor": "pointer" }} onMouseLeave={() => updateHover(false)} onMouseEnter={() => updateHover(item.label)}>
                                    <Space>
                                        <div style={{ "width": "10px", "height": "5px", "backgroundColor": item.color }}></div>
                                        <div style={{ "opacity": "0.7" }}><small><nobr>{item.label}</nobr></small></div>
                                    </Space>
                                </div>
                            )
                        })}
                    </Space>
                </Col>
            </Row>
        </>
    )
}